import { RouteComponentProps, useParams, navigate } from "@reach/router";
import { Typography, Table, Col, Row, Button, Modal } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import ReportDetail from "../component/report/detail";
import { useStore } from "../store";
import Report from "../store/multivers/report";

interface Props extends RouteComponentProps {}
const ReportList = (props: Props) => {
  const [report, setReport] = useState<Report>();
  const { t } = useTranslation();
  const { multivers } = useStore();
  const { administrationId, reportId } = useParams();
  const administration = useMemo(
    () => multivers.administration(administrationId),
    [administrationId]
  );

  const data = administration.reports.docs.slice();
  const isLoaded = data.reduce((acc, report) => acc && report.isLoaded, true);

  useEffect(() => {
    setReport(data.find((report) => report.id === reportId));
  }, [reportId, data]);

  const showReport = (report: Report) => () => {
    navigate(`/${administrationId}/report/${report.id}`);
  };
  const hideReport = () => {
    navigate(`/${administrationId}/report`);
  };

  const columns = [
    {
      title: t("Date"),
      dataIndex: "date",
      key: "date",
    },
    {
      title: t("Device"),
      dataIndex: "device",
      key: "device",
    },
  ];

  const rowHandler = (report: Report) => ({
    onClick: showReport(report),
  });

  return (
    <>
      <Row>
        <Col flex="auto">
          <Typography.Title>{t("Reports")}</Typography.Title>
        </Col>
      </Row>
      <Table
        dataSource={data}
        columns={columns}
        rowKey="id"
        pagination={false}
        onRow={rowHandler}
        loading={!isLoaded}
      />
      <Modal
        title={t("Report")}
        visible={!!report}
        onCancel={hideReport}
        footer={[
          <Button key="ok" type="primary" onClick={hideReport}>
            {t("Ok")}
          </Button>,
        ]}
      >
        {report && <ReportDetail report={report} />}
      </Modal>
    </>
  );
};

export default observer(ReportList);
